<template>
  <div class="slide">
    <div class="grid-container grid-container--medium mb--2rem">
      <div class="grid-x js--insertMobileTooltip">
        <div class="small-12 cell title">
          <h2 class=" mt--0">
            <slot></slot>

            <div class="icons">
              <span
                class="icon standingandlyingbottle fill"
                :class="[icon]"
              ></span
              ><span
                v-if="icon2"
                class="icon standingandlyingbottle fill"
                :class="[icon2]"
              ></span>
            </div>
          </h2>
        </div>
        <div class="small-12 cell mt-3">
          <p><slot name="subheader"></slot></p>
        </div>
      </div>
    </div>

    <div class="grid-container grid-container--medium alcoholSelection">
      <div class="grid-x titles" v-if="currentAlcohols.length">
        <label class="small-3 cell color--primary">
          Type
        </label>
        <label class="small-2 medium-3 cell color--primary">
          Vol.%
        </label>
        <label class="small-4 medium-3 cell color--primary">
          Mengde (dl)
        </label>
        <label class="small-2 medium-3 cell color--primary">
          Antall
        </label>
      </div>

      <div
        class="grid-x alcoholItem js--alcoholItem"
        v-for="(alcohol, i) in currentAlcohols"
        :key="i"
        :style="{ zIndex: 100 - i }"
      >
        <div class="small-3 cell">
          <label :for="`alcoholName--${i}`" class="show-for-sr"
            >Alkoholtype</label
          >
          <select
            :name="`alcoholName--${i}`"
            class="js--autoWidth js--alcoholName show-for-small-only"
            :id="`alcoholName--${i}`"
            v-model="alcohol.name"
            @change="updateAlcoholValues(alcohol, $event)"
          >
            <option
              v-for="(availableAlcohol, index) in availableAlcohols"
              :selected="availableAlcohol.name == alcohol.name"
              :value="availableAlcohol.name"
              :key="index"
              >{{ availableAlcohol.name }}</option
            >
          </select>

          <CustomSelect
            class="show-for-medium"
            :selected="alcohol.name"
            v-on:input="alcohol.name = $event"
            :options="availableNames"
            @input="updateAlcoholValues(alcohol, $event)"
          ></CustomSelect>
        </div>

        <div class="small-2 medium-3 cell">
          <label :for="`alcoholPercentage--${i}`" class="show-for-sr"
            >Alkoholprosent</label
          >
          <div v-if="alcohol.percentages">
            <select
              :name="`alcoholPercentage--${i}`"
              class="js--autoWidth show-for-small-only"
              :id="`alcoholPercentage--${i}`"
              v-model="alcohol.percentage"
            >
              <option
                v-for="(percentage, index) in alcohol.percentages"
                :selected="percentage.percentage == alcohol.percentage"
                :key="index"
                :value="percentage.percentage"
                >{{ percentage.percentage }}</option
              >
            </select>
            <CustomSelect
              class="show-for-medium"
              :selected="alcohol.percentage"
              v-on:input="alcohol.percentage = $event"
              :options="availablePercentages(alcohol)"
            ></CustomSelect>
          </div>
          <input
            v-else
            v-model.number="alcohol.percentage"
            type="number"
            :name="`alcoholPercentage--${i}`"
            min="1"
            max="96"
            :id="`alcoholPercentage--${i}`"
          />
        </div>

        <div class="small-4 medium-3 cell">
          <label :for="`alcoholVolume--${i}`" class="show-for-sr"
            >Alkoholmengde (dl)</label
          >
          <div v-if="alcohol.volumes">
            <select
              :name="`alcoholVolume--${i}`"
              class="js--autoWidth show-for-small-only"
              :id="`alcoholVolume--${i}`"
              v-model="alcohol.volume"
            >
              <option
                v-for="(volume, index) in alcohol.volumes"
                :selected="volume.volume == alcohol.volume"
                :key="index"
                :value="volume.volume"
                >{{ volume.name }} ({{ volume.volume }}dl)</option
              >
            </select>
            <CustomSelect
              class="show-for-medium"
              :selected="alcohol.volume"
              v-on:input="alcohol.volume = $event"
              :options="availableVolumes(alcohol)"
              :texts="availableVolumeNames(alcohol)"
            ></CustomSelect>
          </div>

          <input
            v-else
            v-model="alcohol.volume"
            type="number"
            :name="`alcoholVolume--${i}`"
            min="0"
            max="10"
            :id="`alcoholVolume--${i}`"
          />
        </div>

        <div class="small-2 cell">
          <label :for="`alcoholAmount--${i}`" class="show-for-sr"
            >Antall enheter</label
          >

          <select
            :name="`alcoholAmount--${i}`"
            class="js--autoWidth"
            :id="`alcoholAmount--${i}`"
            v-model="alcohol.quantity"
          >
            <option
              v-for="(alcoAmount, index) in amounts"
              :selected="alcoAmount == alcohol.quantity"
              :key="index"
              :value="alcoAmount"
              >{{ alcoAmount }}</option
            >
          </select>
        </div>

        <div class="small-1 cell flex flex--center">
          <button
            class="alcoholRemove color--current"
            @click="removeAlcohol(alcohol)"
          >
            <span class="alcoholRemove__inner">&times;</span>
          </button>
        </div>
      </div>

      <div class="grid-x">
        <div class="small-12 cell text-center">
          <button class="swBtn swPrimary mt--2rem" @click="addAlcohol">
            + Legg til drikke
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alcohols from "../../appdata/alcohol.js";
import CustomSelect from "./CustomSelect";
export default {
  components: {
    CustomSelect: CustomSelect,
  },
  props: ["currentAlcohols", "icon", "icon2"],
  data() {
    return {
      availableAlcohols: alcohols,
      amounts: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
      ],
    };
  },
  computed: {
    availableNames() {
      var result = Object.keys(this.availableAlcohols).map(
        (key) => this.availableAlcohols[key].name
      );
      return result;
    },
  },

  methods: {
    availablePercentages(alcohol) {
      var result = Object.keys(alcohol.percentages).map(
        (key) => alcohol.percentages[key].percentage
      );
      return result;
    },
    availableVolumes(alcohol) {
      var result = Object.keys(alcohol.volumes).map(
        (key) => alcohol.volumes[key].volume
      );
      return result;
    },
    availableVolumeNames(alcohol) {
      var result = Object.keys(alcohol.volumes).map(
        (key) =>
          alcohol.volumes[key].name + " (" + alcohol.volumes[key].volume + ")"
      );
      return result;
    },
    /**
     * add a unit of alcohol
     */
    addAlcohol() {
      this.currentAlcohols.push({
        name: this.availableAlcohols[0].name,
        percentages: this.availableAlcohols[0].percentages,
        percentage: this.availableAlcohols[0].percentage.percentage,
        volumes: this.availableAlcohols[0].volumes,
        volume: this.availableAlcohols[0].volume.volume,
        quantity: "1",
      });
      setTimeout(function() {
        jQuery("select.js--autoWidth").trigger("change");
      }, 10);
    },
    /**
     * remove a unit of alcohol
     */
    removeAlcohol(alcohol) {
      var index = this.currentAlcohols.indexOf(alcohol);

      if (index > -1) {
        this.currentAlcohols.splice(index, 1);
      }
    },

    updateAlcoholValues(alcohol, event) {
      let index = 0;

      // search for alcohol in all alcohols
      for (var i = 0; i < this.availableAlcohols.length; ++i) {
        if (this.availableAlcohols[i].name == alcohol.name) {
          index = i;
        }
      }

      alcohol.percentages = this.availableAlcohols[index].percentages
        ? this.availableAlcohols[index].percentages
        : null;
      alcohol.percentage = this.availableAlcohols[index].percentage
        ? this.availableAlcohols[index].percentage.percentage
        : 0;
      alcohol.volumes = this.availableAlcohols[index].volumes
        ? this.availableAlcohols[index].volumes
        : null;
      alcohol.volume = this.availableAlcohols[index].volume
        ? this.availableAlcohols[index].volume.volume
        : 0;

      alcohol.quantity = alcohol.quantity ? alcohol.quantity : this.amounts[0];
    },
  },
  mounted() {
    setTimeout(function() {
      jQuery("select.js--autoWidth").trigger("change");
    }, 10);
  },
};
</script>

<style lang="scss">
.title .icons {
  float: none;
  min-width: auto;
  display: inline-block;
}
.title .icon {
  height: 2.5rem;
  width: 2rem;
  padding: 0;
  padding: 1.5rem;
  display: inline-block;
  margin-right: 0.625rem;
  margin-bottom: -0.4rem;
  &.fill {
    padding-bottom: 20%;
    margin: 0 0.625rem -0.4rem 0;
    display: inline-block;
  }
  @media screen and (max-width: 639px) {
    padding: 0.75rem;
    margin-right: 0;
    &.fill {
      margin-right: 0;
      max-width: 100%;
    }
  }
}
.grid-container--medium {
  max-width: 1000px;
}
.alcoholSelection .grid-x {
  margin-left: 0;
  margin-right: 0;
}
.slide {
  overflow: visible;
}
.alcoholItem {
  border-bottom: 0;
  position: relative;
  z-index: 1;
}
.alcoholItem:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  content: " ";
  background: #ccc;
}
.alcoholSelection .titles label {
  cursor: inherit;
}
</style>
